export default __webpack_public_path__ + "static/media/cinema.bcee208a.jpg";